// src/api/meetings.js
import { BASE_API } from "../utils/constants";

export async function generarActaConsolidadaApi(meetingId, token) {
  const url = `${BASE_API}/meetings/${meetingId}/generar_acta_consolidada/`;
  const params = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const res = await fetch(url, params);
  if (!res.ok) throw new Error("Error al generar acta consolidada");
  return await res.json();
}

export async function generarActaAutoApi(meetingId, token) {
  const url = `${BASE_API}/meetings/${meetingId}/generar_acta_auto/`;
  const params = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const res = await fetch(url, params);
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    throw new Error(detail?.error || "Error al generar acta (auto)");
  }
  return await res.json();
}

export async function getActaConsolidadaApi(meetingId, token) {
  const url = `${BASE_API}/meetings/${meetingId}/acta_consolidada/`;
  const res = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    throw new Error(detail?.error || "No hay acta consolidada generada");
  }
  return await res.json(); // { meeting_id, docx_url, preview, version }
}

export function getDescargarActaConsolidadaUrl(meetingId) {
  // si usas el auth header, mejor llama a getActaConsolidadaApi y usa docx_url
  return `${BASE_API}/meetings/${meetingId}/descargar_acta_consolidada/`;
}
